import { RiskItem } from 'src/app/api/models/quotationRequest.model';

export interface RoommateState {
  roommate: RiskItem[] | null;
}

export const initialState: RoommateState = {
  roommate: []
};
